import {Injectable} from '@angular/core';
import {CognitoUtil} from './cognito.service';
import {environment} from '../environments/environment';

// import {Stuff} from '../secure/useractivity/useractivity.component;
import * as AWS from 'aws-sdk/global';
import * as DynamoDB from 'aws-sdk/clients/dynamodb';

@Injectable()
export class DynamoDBService {

    constructor(public cognitoUtil: CognitoUtil) {

    }

    getAWS() {
        return AWS;
    }

    getLogEntries(mapArray: Array<any>) {
        const params = {
            TableName: environment.ddbTableName,
            KeyConditionExpression: 'userId = :userId',
            ExpressionAttributeValues: {
                ':userId': this.cognitoUtil.getCognitoIdentity()
            }
        };

        const docClient = new DynamoDB.DocumentClient();
        docClient.query(params, onQuery);

        function onQuery(err, data) {
            if (err) {
            } else {
                // print all the movies
                data.Items.forEach(function (logitem) {
                    mapArray.push({type: logitem.type, date: logitem.activityDate});
                });
            }
        }
    }

    writeLogEntry(type: string) {
        try {
            const date = new Date().toString();
            this.write(this.cognitoUtil.getCognitoIdentity(), date, type);
        } catch (exc) {
            console.log('DynamoDBService: Couldn\'t write to DDB');
        }

    }

    write(data: string, date: string, type: string): void {
        const DDB = new DynamoDB({
            params: {TableName: environment.ddbTableName}
        });

        // Write the item to the table
        const itemParams = {
                TableName: environment.ddbTableName,
                Item: {
                    userId: {S: data},
                    activityDate: {S: date},
                    type: {S: type}
                }
            };
        DDB.putItem(itemParams, function (result) {  });
    }

}


